export default __webpack_public_path__ + "static/media/koristi-formuli.3409d4cb.gif";